import { useEffect } from 'react';

import cleanXChar from '../../../helpers/cleanXChar';
import { Player } from '../../../types';

const useCleanXChar = (player: Player | null) => {
  useEffect(() => {
    if (!player) return;

    const delayedRun = setTimeout(cleanXChar, 1000);

    return () => clearInterval(delayedRun);
  }, [player]);
};

export default useCleanXChar;
